export const toMillis = (timestamp) => {
	if (!timestamp || typeof timestamp.seconds !== "number") return null
	return timestamp.seconds * 1000
}

export const chunkArray = (array, chunkSize) => {
	const chunks = []
	for (let i = 0; i < array.length; i += chunkSize) {
		chunks.push(array.slice(i, i + chunkSize))
	}
	return chunks
}

export const calculateRate = (numerator, denominator) => {
	if (denominator <= 0) return "N/A"
	return ((numerator / denominator) * 100).toFixed(2)
}

export const formatPercentFromValue = (value) => {
	if (value === "N/A" || value == null) return "N/A"
	const parsed = Number.parseFloat(value)
	if (Number.isNaN(parsed)) return "N/A"
	return `${parsed.toFixed(2)}%`
}

export const formatDecimal = (value, decimalPlaces = 2, fallback = "0.00") => {
	const parsed = Number.parseFloat(value)
	if (Number.isNaN(parsed)) return fallback
	return parsed.toFixed(decimalPlaces)
}

export const formatCurrencyGBP = (value, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
	const parsed = Number.parseFloat(value || 0)
	const output = Number.isNaN(parsed) ? 0 : parsed

	return `£${output.toLocaleString("en-GB", {
		minimumFractionDigits,
		maximumFractionDigits,
	})}`
}

export const formatPaymentsWithAverage = (total, count) => {
	const average = count > 0 ? total / count : 0
	return `${formatCurrencyGBP(total)} (${formatCurrencyGBP(average)})`
}

export const formatCompactDuration = (averageSeconds) => {
	if (averageSeconds == null || Number.isNaN(averageSeconds) || averageSeconds < 0) return "N/A"

	const roundedSeconds = Math.round(averageSeconds)

	if (roundedSeconds >= 86400) {
		const days = Math.floor(roundedSeconds / 86400)
		const hours = Math.floor((roundedSeconds % 86400) / 3600)
		return hours > 0 ? `${days}d ${hours}h` : `${days}d`
	}

	if (roundedSeconds >= 3600) {
		const hours = Math.floor(roundedSeconds / 3600)
		const minutes = Math.floor((roundedSeconds % 3600) / 60)
		return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`
	}

	if (roundedSeconds >= 60) {
		const minutes = Math.floor(roundedSeconds / 60)
		return `${minutes}m`
	}

	return `${roundedSeconds}s`
}
